import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom"
import { DynPopup } from "../../../Components/DynPopup";
import { TextComponent } from "../../../Components/TextComponent";
import { LanguageStringComponent } from "../../../Components/LanguageStringComponent";
import { LanguageString } from "../../../Model/LanguageString";
import { FileUploadControl } from "../../../Controls/FileUpload";
import { FixedDialog } from "../../FixedDialog";
import { app } from "../../../Frame/App";
import { WidgetVideoTutorials } from "../Widgets/WidgetVideoTutorials";
import { ListItem } from "../../../Model/ListItem";
import { ListView } from "../../../Components/ListView/ListView";

export type PopupVideoTutorialsComponentProps = {
    widget: WidgetVideoTutorials;
}

export class PopupVideoTutorialsComponent extends JSXComponent {
    props: PopupVideoTutorialsComponentProps;
    title: LanguageStringComponent;
    fileUploadImageControl: FileUploadControl;
    fileElement: HTMLElement;
    videoTutorials: ListView;
    videoTutorialsList: ListItem[];

    constructor(props: PopupVideoTutorialsComponentProps) {
        super(props);
    }

    onSave = (): boolean => {
        if (this.title.props.model == null)
            this.title.props.model = new LanguageString();
        this.props.widget.props.title = this.title.props.model;
        this.props.widget.props.selectedVideoTutorialIds = this.videoTutorials.getSelectedIds();
        this.props.widget.recreate();
        return true;
    }
    
    element: HTMLElement =
        <DynPopup size="fit" showCancelButton={true} showSaveButton={true} onSave={this.onSave}
            title={Resources['WidgetClient'].videoTutorials} cssClass="popup-video-tutorials-component">
            <div className="mb-3">
                {this.renderTitle()}
            </div>
            <div className="mt-4" style={{ height: "15rem" }}>
                <div className="form-group">
                    {this.renderTutorials()}
                </div>
            </div>
        </DynPopup>

    renderTitle(): HTMLElement {
        this.title = new LanguageStringComponent({
            model: this.props.widget.props.title,
            name: Resources['WidgetClient'].title,
            additionalCssClasses: "name-in-languages",
            maxLength: 250,
            showLabel: true,
            alwaysExpanded: false
        }); 
        return this.title.render();
    }

    renderTutorials(): HTMLElement {
        this.getData();
        this.videoTutorials = new ListView({
            name: Resources['WidgetClient'].tutorials,
            displayProperty: "nameInLanguage",
            idProperty: "id",
            checkedProperty: "checked",
            model: this.videoTutorialsList,
            allowSelect: true,
            selectedIds: this.props.widget.props.selectedVideoTutorialIds,
        });
        return this.videoTutorials.render();
    }

    getData(): void {
        $.ajax({
            url: app.resolveUrl(`~/api/widget/getVideoTutorials`),
            type: "GET",
            dataType: 'json',
            async: false,
            success: (items: ListItem[]) => {
                this.videoTutorialsList = items;
            },
            error: ((response) => {
                app.addError(response.statusText + ": " + response.responseText);
            })
        });
    }

    onFileUploadWrongExtension(fileUploadControl: FileUploadControl, extension: string) {
        this.showWrongExtensionMessage(fileUploadControl, extension);
    }

    showWrongExtensionMessage(fileUploadControl: FileUploadControl, extension: string) {
        new FixedDialog(fileUploadControl.element)
            .showOk((Resources.Common.fileUploadInvalidExtension).format(extension), 100, -30);
    }

    render(): HTMLElement {
        return this.element;
    }
}
